import React, { useEffect, useState } from 'react'
import { CustomButton, FilterBar, TableData, TxnLogView } from '../../components';
import DownloadIcon from "@mui/icons-material/Download";
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { useDispatch, useSelector } from 'react-redux';
import { setConciliacionesDiferenciasReport, setConciliacionesReport } from '../../redux/slices/report/reportSlice';
import { getProvidersService, getConciliacionesDiferenciasReportService, getConciliacionesReportService, downloadConciliacionesReportService, getTxnsNoConciliadasProveedorService } from '../../services/report/reportService';
import { confirmAlert, errorAlert } from '../../helpers/alerts';
import moment from 'moment';
import { setTitle } from '../../redux/slices/uiSlice';
import { currencyFormatter, currencyIntFormatter, downloadFile, sortArrayBy } from '../../helpers/util';
import ColumnFilterModal from "../../components/modal/ColumnFilterModal";
import { Loader } from 'rsuite';
import { BugReport, CompareArrows, DownloadingOutlined, Filter1Outlined, FlipToBack, ListAlt, SettingsBackupRestore } from '@mui/icons-material';
import { getAllProviderCredsService } from 'services/admin/providerService';
import Image from 'components/common/Image';
import Images from 'assets/images';
import { Box } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import DialogModal from 'components/modal/DialogModal';
import ConciliationLogModal from 'components/modal/ConciliationLogModal';
import { getLogsTxnService } from 'services/panelService';
import { createAclaracionService } from 'services/admin/taskService';
import ConciliacionTxnLogView from 'components/report/ConciliacionTxnLogView';

const ConciliacionScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });
  const [logId, setLogId] = useState(null)

  // El correo de alerta de conciliación enlaza aquí con ?cred=<id>&fecha=YYYY-MM-DD
  // (el día conciliado). Sin esos parámetros, la pantalla se comporta como siempre.
  const linkedCred = searchParams.get('cred') || undefined;
  const linkedDate = moment(searchParams.get('fecha'), 'YYYY-MM-DD', true);
  const initialDate = linkedDate.isValid()
    ? linkedDate.toDate()
    : location.state?.date ? moment(location.state.date, 'DD/MM/YYYY').toDate() : moment().subtract(1, 'days').toDate();
  const columns_diferencias = [
    // { name: "provider", label: "Proveedor", format: ({ cred }) => cred.conciliacion_service },
    { name: "date", label: "Fecha", format: ({ createdAt }) => moment(createdAt).subtract(1, 'days').format('DD/MM/YYYY') },
    { name: "cred", label: "Instancia", format: ({ cred }) => ({ type: 'text', value: cred.name_connector, maxWidth: 80 }) },
    { name: "hebe_txns", label: "HEBE Tx", format: ({ hebe_txns }) => hebe_txns || '-' },
    { name: "saldo_gastado", label: "HEBE Monto", format: ({ hebe_amount }) => hebe_amount ? currencyIntFormatter.format(hebe_amount) : '-' },
    { name: "provider_txns", label: "Prov Tx", format: ({ provider_txns }) => provider_txns || '-' },
    { name: "provider_amount", label: "Prov Monto", format: ({ provider_amount }) => provider_amount ? currencyIntFormatter.format(provider_amount) : '-' },
    { name: "total_txns_no_conciliadas", label: "Tx Conciliadas", format: ({ conciliado_txns }) => conciliado_txns || '-' },
    { name: "saldo_conciliado", label: "Monto Conciliado", format: ({ conciliado_amount }) => conciliado_amount ? currencyIntFormatter.format(conciliado_amount) : '-' },
    { name: "estatus", label: "Estatus", format: ({ status }) => ({ type: 'text', value: status || '-', maxWidth: 80 }) },
    { name: "monto_diff", label: "Diferencia Concilliado", format: ({ hebe_amount, provider_amount }) => (hebe_amount && provider_amount) ? currencyIntFormatter.format(hebe_amount - provider_amount) : '-' }
  ]

  const columns = [
    { category: 'Entidad', name: "origin", label: "Origen", format: ({ origin }) => origin },
    { category: 'Entidad', name: "cred", label: "Instancia", format: ({ serviceCredId }) => ({ type: 'text', value: providerCreds?.find(cred => cred.id === serviceCredId)?.name_connector || '-', maxWidth: 80 }) },
    { category: 'Destino', name: "type", label: "Movimiento", format: ({ typeReg }) => typeReg },
    { category: 'Destino', name: "operator", label: "Operadora", format: ({ providerCarrier, data, serviceCredId }) => providerCarrier || data?.operadorServicio || (providerCreds?.find(cred => cred.id === serviceCredId)?.name_connector?.includes('teria') ? 'Telcel' : null) || '-' },
    { category: 'Destino', name: "phone", label: "Telefono", format: ({ phoneNumber }) => phoneNumber },
    { category: 'Destino', name: "import", label: "Importe", format: ({ typeReg, Amount, operacionSaldo }) => currencyIntFormatter.format(typeReg === 'TAE' ? Amount : operacionSaldo) },
    { category: 'Resultado', name: "state", label: "Estado", format: ({ typeReg, ProviderResponseMessage }) => typeReg === 'TAE' ? ProviderResponseMessage : '' },
    { category: 'Resultado', name: "datetime", label: "Fecha y hora", format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    { category: 'Resultado', name: "auth", label: "Autorización", format: ({ AuthCode }) => AuthCode },
    { category: 'Resultado', name: "code", label: "Codigo", format: ({ ProviderResponseCode }) => ProviderResponseCode },
    { category: 'Resultado', name: "time", label: "Tiempo", format: ({ createdAt, endTxn, updatedAt, origin }) => origin === 'HEBE' ? `${(endTxn || updatedAt) - createdAt} ms` : '' },
  ]
  const { conciliacionesDiferenciasReport, conciliacionesReport } = useSelector(store => store.reports);
  const [loadingCD, setLoadingCD] = useState(false)
  const [loadingC, setLoadingC] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [downloadFilters, setDownloadFilters] = useState({})
  const [providerCreds, setProviderCreds] = useState(null)
  const [showColumnFilterModal, setShowColumnFilterModal] = useState(false)
  const [selectedColums, setSetSelectedColums] = useState([
    "origin",
    "cred",
    "type",
    "operator",
    "phone",
    "import",
    "state",
    "datetime",
    "auth",
    "code",
    "time",
  ])

  useEffect(() => {
    dispatch(setTitle('Conciliaciones'));
    getAllProviderCredsService().then(creds => {
      let list = creds.filter(item => item.provider && !['smartgateiso', 'sandbox', 'certificacion'].includes(item.conciliacion_service));
      setProviderCreds(list);
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);
  // useEffect(() => {
  //   getProvidersService({})
  //     .then((response) => setProviders(response || []))
  //     .catch((e) => errorAlert(e))
  //   // eslint-disable-next-line
  // }, []);

  const handlerSubmitCD = async (data) => {
    setLoadingCD(true)
    setDownloadFilters(data)
    getConciliacionesDiferenciasReportService(data)
      .then((response) => dispatch(setConciliacionesDiferenciasReport(response.filter(item => data.actives ? item.status !== 'Sin Registros' : true) || [])))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingCD(false));
  }

  const handlerSubmitC = async (data) => {
    setLoadingC(true)
    setDownloadFilters(data)
    getConciliacionesReportService(data)
      .then((response) => dispatch(setConciliacionesReport(response)))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingC(false));
  }

  const handlerDownload = async () => {
    setLoadingDownload(true)
    downloadConciliacionesReportService(downloadFilters)
      .then((data) => downloadFile(data, 'Conciliaciones.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingDownload(false));
  }

  const handlerSelectColumn = (columns) => {
    setSetSelectedColums(columns)
    setShowColumnFilterModal(false)
  }

  return (
    <>
      <FilterBar
        handlerFilter={(data) => {
          handlerSubmitCD(data);
          handlerSubmitC(data);
        }}
        defaultValues={{
          actives: true,
          cred: linkedCred,
          date: [initialDate, initialDate],
        }}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            name: "cred",
            label: "Instancia",
            type: "select",
            data: providerCreds?.map(item => ({
              id: item.id,
              name: item.name_connector,
            })) || [],
            loading: providerCreds == null,
          },
          {
            type: "checkbox",
            name: "actives",
            label: "Solo Activas",
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loadingCD}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={<Image src={Images.icon.columnas} />}
              key="filterColumns"
              name={"Columnas"}
              click={() => setShowColumnFilterModal(true)}
            />,
            loadingDownload ? <Loader size='md' /> : <CustomButton
              dark={true}
              icon={Images.icon.download}
              key="dowloadBalance"
              name={"Descargar"}
              click={handlerDownload}
            />,
          ]}
          dataRows={sortArrayBy(conciliacionesDiferenciasReport, item => item.cred.name_connector)}
          dataTitle={columns_diferencias.map(({ label }) => label)}
          formatter={(data) => columns_diferencias.map(({ format }) => format(data))}
          actions={[
            {
              icon: <ListAlt />,
              label: 'Ver log',
              validate: (data) => Boolean(data?.id || data?._id),
              onClick: (data) => setLogId(data.id || data._id)
            }
          ]}
        />
        {console.log(conciliacionesReport)}
        <TableData
          loading={loadingC}
          dataRows={(conciliacionesReport || []).map(item => ({ ...item, createdAt: moment(item.createdAt) })).sort((a, b) => b.createdAt - a.createdAt)}
          dataTitle={columns.filter(({ name }) => selectedColums.includes(name)).map(({ label }) => label)}
          formatter={(data) => columns.filter(({ name }) => selectedColums.includes(name)).map(({ format }) => format(data))}
          actions={[
            {
              label: "Logs",
              icon: <BugReport />,
              onClick: async (data) => {
                // Una fila de HEBE ya es la transaccion: se pide su log y se pinta.
                if (data.origin === 'HEBE') {
                  const result = await getLogsTxnService(data._id);
                  setDialog({
                    open: true,
                    maxWidth: 'lg',
                    title: `Log Transacción ${data._id}`,
                    textAlign: 'left',
                    body: <TxnLogView data={result} />,
                    onClose: () => setDialog({ open: false })
                  })
                  return;
                }
                // Una fila del proveedor no trae identificador de transaccion -- si lo
                // trajera estaria conciliada --, asi que el dialogo busca las de ese
                // numero ese dia y ensena el log de la que se elija.
                setDialog({
                  open: true,
                  maxWidth: 'lg',
                  title: `Transacción del proveedor · ${data.phoneNumber || '-'}`,
                  textAlign: 'left',
                  body: <ConciliacionTxnLogView
                    record={data}
                    instancia={providerCreds?.find(cred => cred.id === data.serviceCredId)?.name_connector}
                    fallbackDate={downloadFilters?.date?.[0]}
                  />,
                  onClose: () => setDialog({ open: false })
                })
              },
            },
            {
              label: "Registros",
              icon: <CompareArrows />,
              validate: ({ origin }) => origin == 'Proveedor',
              onClick: async (data) => {
                navigate('/reportes/buscar_txn', {
                  state: {
                    phone: data.phoneNumber,
                    period: 'month'
                  }
                })
              },
            },
            {
              label: "Rembolso",
              icon: <SettingsBackupRestore />,
              validate: ({ task }) => !task,
              onClick: async (data) => {
                confirmAlert({
                  title: "Crear aclaración",
                  text: `La transacción con autorizacion ${data.AuthCode} será marcada para aclaración.`,
                  onConfirm: async () => {
                    createAclaracionService(data).then((resp) => {
                      dispatch(setConciliacionesReport(conciliacionesReport.map(item => item._id === data._id ? { ...item, task: resp.id } : item)));
                    }).catch((e) => { errorAlert(e) })
                  }
                })
              },
            },
          ]}
        />
      </Box>
      <ColumnFilterModal
        open={showColumnFilterModal}
        columns={columns}
        selected={selectedColums}
        onSuccess={handlerSelectColumn}
        onClose={() => setShowColumnFilterModal(false)}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
      <ConciliationLogModal
        id={logId}
        open={Boolean(logId)}
        onClose={() => setLogId(null)}
      />
    </>

  )
}

export default ConciliacionScreen